export class CalcBox {
  constructor(
    public expectedYield: number,

    public cleanPrice: number,

  ) { }
}
